<script setup lang="ts">
/**
 * Final Dividends — Minutes of EGM (Multiple Members).
 *   원본: Minutes of EGM – Final Dividends (Multiple Members).
 *   주주×금액 표 = shareholders 반복(백엔드 등록 루프명). Present 목록도 같은 shareholders.
 *   서명 없음 — 의장 확인란(밑줄 + [[Chairman_Name]]).
 */
import { inject, ref } from 'vue';
import CddVarField from '../cdd/CddVarField.vue';
import { DIV_MEMBERS } from './members';
import './agmDoc.css';

const members = inject(DIV_MEMBERS, { ids: ref<number[]>([1]), add: () => {}, remove: () => {} });
</script>

<template>
  <div class="agm-doc">
    <div class="doc-head">
      <div><b><CddVarField field-key="company_name" label="Company Name" /></b></div>
      <div>Company Registration No. <CddVarField field-key="company_registration_no" label="Reg No" /></div>
      <div>(Incorporated in the Republic of Singapore)</div>
      <div>(the &ldquo;Company&rdquo;)</div>
    </div>

    <div class="doc-title">MINUTES OF EXTRAORDINARY GENERAL MEETING</div>

    <table class="cdd-tbl">
      <tbody>
        <tr><td class="cdd-lcell">Venue</td><td><CddVarField field-key="meeting_venue" label="Meeting Venue" /></td></tr>
        <tr><td class="cdd-lcell">Date</td><td><CddVarField field-key="meeting_date" label="Meeting Date" /></td></tr>
        <tr><td class="cdd-lcell">Time</td><td><CddVarField field-key="meeting_time" label="Meeting Time" /></td></tr>
      </tbody>
    </table>

    <p class="doc-p"><b>Present:-</b></p>
    <div class="list-editor">
      <div v-for="id in members.ids.value" :key="id" class="list-row">
        <CddVarField :field-key="`mem_${id}/member_name`" label="Member Name" />
        <button v-if="members.ids.value.length > 1" type="button" class="list-rm" title="Remove member" @click="members.remove(id)">×</button>
      </div>
      <button type="button" class="list-add" @click="members.add()">+ Add member</button>
    </div>

    <div class="sec-title">CHAIRMAN</div>
    <p class="doc-p"><CddVarField field-key="chairman_name" label="Chairman Name" /> was elected chairman of the meeting.</p>
    <div class="sec-title">QUORUM</div>
    <p class="doc-p">The Chairman after having ascertained that a quorum was present called the Meeting to order.</p>
    <div class="sec-title">NOTICE OF MEETING</div>
    <p class="doc-p">Notice of the meeting was taken as read.</p>

    <div class="sec-title">BUSINESS</div>
    <div class="sec-title" style="text-align:center">FINAL DIVIDEND</div>
    <p class="doc-p">
      IT WAS NOTED THAT the Company has sufficient profits for the declaration of a final dividend of
      <CddVarField field-key="dividend_amount" label="Dividend Amount" /> to its members.
    </p>
    <p class="doc-p">
      IT WAS RESOLVED THAT a final one-tier tax exempt dividend of <CddVarField field-key="dividend_amount" label="Dividend Amount" />
      in respect of the financial year ended <CddVarField field-key="financial_year_end" label="Financial Year End" />
      be recommended for payment out of the profits of the Company to the members whose names appear on the Register of Members as follows:-
    </p>

    <table class="cdd-tbl">
      <thead><tr><th>Members</th><th>Amount</th><th></th></tr></thead>
      <tbody>
        <tr v-for="id in members.ids.value" :key="id">
          <td><CddVarField :field-key="`mem_${id}/member_name`" label="Member Name" /></td>
          <td><CddVarField :field-key="`mem_${id}/amount_to_receive`" label="Amount" /></td>
          <td style="width:24px;text-align:center"><button v-if="members.ids.value.length > 1" type="button" class="list-rm" title="Remove" @click="members.remove(id)">×</button></td>
        </tr>
        <tr><td><b>TOTAL</b></td><td><CddVarField field-key="total_dividend_amount" label="Total Dividend Amount" /></td><td></td></tr>
      </tbody>
    </table>
    <button type="button" class="list-add" @click="members.add()">+ Add member</button>

    <div class="sec-title">CONCLUSION</div>
    <p class="doc-p">There being no other business, the meeting ended with a vote of thanks to the chairman.</p>

    <p class="doc-p" style="text-align:right">Confirmed by,</p>
    <div class="sign-line"></div>
    <p class="doc-p"><CddVarField field-key="chairman_name" label="Chairman Name" /><br />Chairman of the meeting</p>
  </div>
</template>
